import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 4A709F16-7813-44DA-AB19-EBEBB4A6718A
 * name circle-box-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-box-outline.svg
 * tags
 */
export const CircleBoxOutlineIcon = createSvgIcon(<><path d="M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 8C9.79 8 8 9.79 8 12S9.79 16 12 16 16 14.21 16 12 14.21 8 12 8Z" /></>, 'CircleBoxOutlineIcon');
export default CircleBoxOutlineIcon